import React from "react";

// Components
import ListRekening from "./ListRekening";

// react-router-dom
import { useHistory } from "react-router-dom";

// Material-UI
import { Button, Divider, Typography } from "@material-ui/core";

// useStyles
import useStyles from "./styles";

import Header from "../../../components/molecules/Header";
import { useData } from "../../../components/firebase/DataProvider";
import { useState } from "react";
import DialogRekening from "./dialog";

export default function Rekening() {
  const history = useHistory();

  const classes = useStyles();

  const { bankSeller } = useData();

  const [dialog, setDialog] = useState({
    open: false,
    data: {},
    mode: "Tambah",
  });

  return (
    <>
      <div className={classes.root}>
        <Header
          type="with-title"
          title="Daftar Rekening"
          onClick={() => history.push("/akun")}
        />
        {/* <Gap height={60} /> */}
        <div className={classes.btnWrapper}>
          <Divider style={{ margin: "15px -15px" }} />
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            // className={classes.btn}
            onClick={() => setDialog({ open: true, data: {}, mode: "Tambah" })}
          >
            Tambah Rekening
          </Button>
          <Divider style={{ margin: "15px -15px" }} />
        </div>
        <div className={classes.contentWrapper}>
          {bankSeller?.length > 0 ? (
            bankSeller?.map((item) => {
              return (
                <ListRekening
                  key={item.id}
                  data={item}
                  length={bankSeller.length}
                />
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                // justifyContent: "space-between",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
                height: "75px",
                borderRadius: 8,
                marginBottom: "20px",
                padding: "10px",
                backgroundColor: "gainsboro",
              }}
            >
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  fontSize: 15,
                  // marginTop: "2.5%",
                  fontWeight: "bold",
                }}
              >
                Rekening Masih Kosong
              </Typography>
            </div>
          )}
        </div>
      </div>
      <DialogRekening
        open={dialog.open}
        data={dialog.data}
        mode={dialog.mode}
        handleClose={() => setDialog({ open: false, data: {}, mode: "Tambah" })}
      />
    </>
  );
}
